import * as Yup from 'yup'

export const getRingDurationOptions = (t) =>
  [15, 25, 45, 60, 90, 120].map((seconds) => ({
    value: seconds,
    label: t('chat:callingSettings.ringDurationOption', { seconds }),
  }))

export const voicemailFormValidation = (t) => ({
  name: Yup.string()
    .min(1, t('chat:voicemailValidation.maxOneCharacter'))
    .max(30, t('chat:voicemailValidation.maxThirtyCharacters'))
    .required(t('chat:voicemailValidation.required')),
  text: Yup.string(),
  recording: Yup.mixed(),
})
